const getSortOptions = (options, key, sort) => {
  if (!isFieldSortable(options, key)) {
    return {
      canSort: false
    };
  }
  return {
    canSort: true,
    direction: getSortDirection(key, sort)
  };
};
const getSortDirection = (key, sort) => {
  var _a;
  if (key === (sort == null ? void 0 : sort.key)) {
    return (_a = sort.direction) != null ? _a : "asc";
  }
  return void 0;
};
const isFieldSortable = (options, key) => {
  var _a, _b, _c, _d, _e;
  if (((_a = options == null ? void 0 : options.sort) == null ? void 0 : _a.enabled) === false) {
    return false;
  }
  return (_e = (_d = (_c = (_b = options == null ? void 0 : options.sort) == null ? void 0 : _b.keys) == null ? void 0 : _c[key]) == null ? void 0 : _d.canSort) != null ? _e : true;
};

export { getSortDirection, getSortOptions, isFieldSortable };
